var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgECar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.217,
    height: 14,
    viewBox: "0 0 14.217 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    transform: "translate(-389.379 -595.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M415.333,610.264a.509.509,0,0,0-.509.508v1.658h1.017v-1.658A.508.508,0,0,0,415.333,610.264Z",
    transform: "translate(-20.37 -11.497)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M430.63,610.264a.509.509,0,0,0-.509.508v1.658h1.017v-1.658A.508.508,0,0,0,430.63,610.264Z",
    transform: "translate(-32.617 -11.497)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M396.487,595.9a7.109,7.109,0,0,0-1.814,13.983.5.5,0,0,0,.254-.964,6.11,6.11,0,1,1,3.533-.124.774.774,0,0,1-.672-.109c-.3-.21-.784-.849-.858-2.76h.036a2.284,2.284,0,0,0,2.284-2.284v-1.786a.4.4,0,0,0-.4-.4h-4.736a.4.4,0,0,0-.4.4v1.786a2.283,2.283,0,0,0,2.209,2.281c.066,1.844.505,3.054,1.31,3.6a1.773,1.773,0,0,0,1.568.208,7.11,7.11,0,0,0-2.323-13.829Z",
    transform: "translate(0)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECar);
export default __webpack_public_path__ + "static/media/e-car.3172f845.svg";
export { ForwardRef as ReactComponent };